import DatabasesAndPolicies from '../../../../databasesAndPolicies/databasesAndPolicies'
import ScanStatusCompact from '../../../../scanStatus/scanStatusCompact'
import useUrlContext from '../../../../../hooks/useUrlContext'
import { DATA_SOURCE_TYPE, DATA_SOURCE_TYPES } from '../../../../../constants'
import { RootState } from '../../../../../rootReducer'
import { DataSource } from '../../../../../services/api/apiTypes'
import { getSelectedDataSourceWidget } from '../../../../dataSources/dataSourcesSlice'
import { getUniqueWidgetIndex, UNIQUE_WIDGET_INDEX } from '../../constants'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'

interface OwnProps {
  useMockData?: boolean
  widgetDatasourceId?: string
  widgetDatasourceType?: DATA_SOURCE_TYPES
  widgetDashboardId?: string
}

interface StateProps {
  selectedDataSource: DataSource | null
}

interface DispatchProps {
  getSelectedDataSourceWidget: (params: { id: string; [UNIQUE_WIDGET_INDEX]?: string }) => void
}

type IProps = OwnProps & StateProps & DispatchProps

const StructuredOverviewWidget = ({
  selectedDataSource,
  useMockData = false,
  widgetDatasourceId,
  widgetDatasourceType,
  widgetDashboardId,
  getSelectedDataSourceWidget
}: IProps) => {
  const context = useUrlContext()
  const datasourceType =
    widgetDatasourceType || (context.queryParams[DATA_SOURCE_TYPE] as DATA_SOURCE_TYPES)

  const widgetIndex = getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)

  useEffect(() => {
    if (widgetDatasourceId) {
      getSelectedDataSourceWidget({ id: widgetDatasourceId, [UNIQUE_WIDGET_INDEX]: widgetIndex })
    }
  }, [getSelectedDataSourceWidget, widgetDatasourceId, widgetIndex])

  const skippedDbs =
    selectedDataSource?.additionalMetadata?.skippedItems?.map((db) => ({
      database: db.database
    })) || []

  return (
    <div className="lb-widget-card xs-p-16">
      <DatabasesAndPolicies
        skippedDbs={skippedDbs}
        useMockData={useMockData}
        widgetDatasourceId={widgetDatasourceId}
        widgetDashboardId={widgetDashboardId}
        widgetDatasourceType={widgetDatasourceType}
      />
      <ScanStatusCompact
        widgetDatasourceId={widgetDatasourceId}
        datasourceType={datasourceType}
        useMockData={useMockData}
        widgetDashboardId={widgetDashboardId}
        widgetDatasourceType={widgetDatasourceType}
      />
    </div>
  )
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  const widgetIndex = getUniqueWidgetIndex(ownProps.widgetDashboardId, ownProps.widgetDatasourceId)
  return {
    selectedDataSource: state.dataSources.widgetDataSelectedDataSource?.[widgetIndex]
  }
}

const mapDispatchToProps = {
  getSelectedDataSourceWidget
}

export default connect(mapStateToProps, mapDispatchToProps)(StructuredOverviewWidget)
